import { render } from "./GuardRequest.vue?vue&type=template&id=1dcea402"
import script from "./GuardRequest.vue?vue&type=script&lang=js"
export * from "./GuardRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__